import { render, staticRenderFns } from "./IconPower.vue?vue&type=template&id=739e40b0&"
import script from "./IconPower.vue?vue&type=script&lang=ts&"
export * from "./IconPower.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports